import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-reset-icon',
  templateUrl: './reset-icon.component.html'
})
export class ResetIconComponent {
  /** Tailwind size classes */
  @Input() size = 'w-4 h-4';

  /** Tailwind color classes */
  @Input() color = 'text-gray-400';
}
